import Hero from "../../components/Hero/Hero";
import HomePath from "../../components/HomePath/HomePath";
import TestimonialSection from "../../components/TestimonialSection/TestimonialSection";
import SuccessHome from "../../components/SuccessHome/SuccessHome";
const Home = () => {
  return (
    <>
      <Hero />
      <HomePath />
      <SuccessHome />
      <TestimonialSection />
    </>
  );
};
export default Home;
